import React from 'react';
import PropTypes from "prop-types";

import {DateFormatter} from "../../../services/date";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


const BookingItem = ({arrival, departure, price, name, accommodationName})=> {
    return (
        <Paper variant="outlined" sx={{p: 1.5, my: 1}}>
            <Stack direction="row"
                   justifyContent="space-between"
                   alignItems="flex-start"
                   spacing={0.5}>
                <Box>
                    <Typography variant="body2" fontWeight="medium">
                        {name}
                    </Typography>
                    <Typography variant="body2" fontWeight="light">
                        {accommodationName}
                    </Typography>
                </Box>
            </Stack>

            <Stack direction="row"
                   justifyContent="space-between"
                   alignItems="flex-start"
                   spacing={0.5}
                   sx={{mt:0.5}}>
                <Typography variant="caption" fontWeight="normal">
                    {DateFormatter.shortString(arrival)} - {DateFormatter.shortString(departure)}
                </Typography>
                {
                    price &&
                    <Typography fontWeight="medium" textAlign="right">
                        {`${price} €`}
                    </Typography>
                }
            </Stack>
        </Paper>
    )
};

BookingItem.propTypes = {
    arrival: PropTypes.object.isRequired,  // a date object
    departure: PropTypes.object.isRequired,  // a date object
    name: PropTypes.string.isRequired,
    accommodationName: PropTypes.string.isRequired,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string])  // price can be a number or a string (if it's not set, it can be an empty string)
}

export default BookingItem;